import breakpoints from '../../style/breakpoints.module.css';

const { tabletBreakpoint, mobileBreakpoint, noSupportedBreakpoint } =
  breakpoints;

const removePx = (value: string) => {
  return parseInt(value.replace('px', ''));
};

const isNotSupported = () => {
  return window.innerWidth < removePx(noSupportedBreakpoint);
};

const isMobile = () => {
  return window.innerWidth < removePx(mobileBreakpoint);
};

const isTablet = () => {
  return (
    window.innerWidth >= removePx(mobileBreakpoint) &&
    window.innerWidth < removePx(tabletBreakpoint)
  );
};

const isDesktop = () => {
  return window.innerWidth >= removePx(tabletBreakpoint);
};

export const mediaBreakpointsUtils = {
  isMobile,
  isTablet,
  isDesktop,
  isNotSupported,
};
